
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { InterviewSubmissionFacade } from '@/services/interview';

interface UseFormSubmissionProps {
  requestLink: string;
}

interface FormData {
  answer: string;
  name: string;
  title: string;
  company: string;
  photographerCredit: string;
  photoUrl: string;
}

interface UseFormSubmissionReturn {
  submitting: boolean;
  handleSubmit: (formData: FormData) => Promise<void>;
}

export const useFormSubmission = ({ requestLink }: UseFormSubmissionProps): UseFormSubmissionReturn => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (formData: FormData): Promise<void> => {
    console.log('=== FORM SUBMISSION START ===');
    console.log('Form handleSubmit called with requestLink:', requestLink);
    console.log('Form handleSubmit requestLink type:', typeof requestLink);
    console.log('Form handleSubmit requestLink value:', `"${requestLink}"`);
    
    if (!formData.answer.trim()) {
      toast.error('Vennligst oppgi et svar');
      return;
    }

    if (!formData.name.trim()) {
      toast.error('Vennligst oppgi ditt navn');
      return;
    }

    if (!requestLink) {
      toast.error('Ugyldig forespørselslenke');
      return;
    }

    setSubmitting(true);

    try {
      const result = await InterviewSubmissionFacade.submitInterviewResponse({
        requestLink,
        answer: formData.answer.trim(),
        name: formData.name.trim(),
        title: formData.title.trim(),
        company: formData.company.trim(),
        photographerCredit: formData.photographerCredit.trim(),
        photoUrl: formData.photoUrl
      });

      if (result.success) {
        toast.success('Intervju sendt inn!');
        navigate('/interview-success');
      } else {
        toast.error(result.error || 'Kunne ikke sende inn intervjusvar');
      }
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : 'Kunne ikke sende inn intervjusvar';
      toast.error('Feil ved innsending av svar. Vennligst prøv igjen senere.');
    } finally {
      setSubmitting(false);
    }
  };

  return {
    submitting,
    handleSubmit
  };
};
